import { USER_DATA } from "../constants/localStorageKeys";
import { save, retrieve, remove } from "../helpers/StorageHelper";
import { create } from "zustand";

// Hydrate initial user synchronously from localStorage
const initialUser = retrieve(USER_DATA);

const useUserStore = create((set, get) => ({
  user: initialUser ?? null,

  setUser: (user) => {
    if (user) {
      set({ user });
      save(USER_DATA, user);
    } else {
      set({ user: null });
      remove(USER_DATA);
    }
  },

  getUser: () => {
    const user = retrieve(USER_DATA);
    if (user) {
      set({ user });
    }
  },

  removeUser: () => {
    if (get().user) {
      set({ user: null });
      remove(USER_DATA);
    }
  },
}));

export default useUserStore;
